const StatusMapping = {
  Running: "service-running-state"
};

module.exports = StatusMapping;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/StatusMapping.js